import type { JSX } from 'react';
import markNavy from '@/assets/logo-navy-transparent.png';
import markWhite from '@/assets/logo-white-transparent.png';

/**
 * The Partnership Net mark.
 *
 * The brand asset itself, not a reproduction of it. `partnershipnet-brand`
 * non-negotiable 6 says the logo is an image and never typed text; a hand-drawn
 * SVG approximating the mark from circles and strokes is the same failure in a
 * different medium, and it is what used to be here. Both files are copied
 * byte-for-byte out of the skill's `assets/` so they can be diffed against it,
 * and both already carry an alpha channel — nothing here punches out a
 * background, because there is none to punch out.
 *
 * Two treatments, because the mark flips with the ground it sits on (the same
 * rule the deck footer follows). The rail's logo card is white, so the navy
 * mark is the default; the white one is for placement directly on navy.
 *
 * No client or rights-holder mark appears anywhere in this application, which
 * remains a hard brand rule.
 */
export function Logo({
  size = 30,
  light = false,
}: {
  readonly size?: number | undefined;
  /** Inverted treatment, for placement directly on a navy surface. */
  readonly light?: boolean | undefined;
}): JSX.Element {
  return (
    <img
      src={light ? markWhite : markNavy}
      alt="Partnership Net"
      // The asset is 512x416, so height is the binding dimension at the 44px
      // card's 30px inner cap. Width follows the aspect ratio rather than being
      // stated, which is what stops the mark being squashed if the cap changes.
      style={{ height: size, width: 'auto', maxWidth: size, display: 'block' }}
    />
  );
}
